export enum Types {
  SET_OBSERVABILITY_INITIALIAZED = 'observalibity/SET_OBSERVABILITY_INITIALIAZED',
  SET_OBSERVABILITY_INITIALIAZED_SUCCESS = 'observalibity/SET_OBSERVABILITY_INITIALIAZED_SUCCESS',
  OBSERVABILITY_ERROR = 'observalibity/OBSERVABILITY_ERROR'
}

export interface IObservalibilityState {
  initialized: boolean;
}
